import { Providers, ProviderState} from '@microsoft/mgt-element';
import { useState, useEffect } from 'react';

const useIsSignedIn = () => {
    const [isSignedIn, setIsSignedIn] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
  
    useEffect(() => {
      const updateState = () => {
        const provider = Providers.globalProvider;
        console.log(ProviderState.SignedIn);
        setIsSignedIn(provider && provider.state === ProviderState.SignedIn);
      };
  
      Providers.onProviderUpdated(updateState);
      updateState();
  
      return () => {
        Providers.removeProviderUpdatedListener(updateState);
      }
    }, [userDetails]);
    return [isSignedIn];
  }

  export default useIsSignedIn;